import { observer } from 'mobx-react-lite';
import { CheckboxField, Widget, WidgetProps } from '../../../../../components';
import Product from '../../../store/Product';

export default observer(function ProductMergingWidget({
  product,
  ...rest
}: { product: Product } & WidgetProps) {
  return (
    <Widget surface="gray" title="Product Merging" {...rest}>
      <CheckboxField
        helperText="Allow installing products with the same name to the same location"
        label="Can be merged with other products"
        name="isMergeable"
        onChange={product.extendedFeatures.productMerging.handleChange}
        sx={{ mt: 0 }}
        value={product.extendedFeatures.productMerging.isMergeable}
      />
    </Widget>
  );
});
